/* Reuse the collection's existing category toggle and its accessible state. */
(() => {
  function init() {
    const shell = document.querySelector('.template-collection .kr-food-shell');
    const toggle = shell?.querySelector('[data-collection-rail-toggle]');
    if (!shell || !toggle || shell.dataset.autoCollapseReady) return;
    shell.dataset.autoCollapseReady = 'true';
    const mobile = window.matchMedia('(max-width: 900px)');
    let handled = false;
    let lastY = window.scrollY;
    let queued = false;
    // A deliberate toggle choice always takes precedence over automatic hiding.
    toggle.addEventListener('click', () => { handled = true; });
    function update() {
      queued = false;
      const y = window.scrollY;
      if (!handled && mobile.matches && y > 64 && y > lastY) {
        handled = true;
        if (!shell.classList.contains('is-rail-collapsed') && !shell.querySelector('.food-categories')?.contains(document.activeElement)) {
          toggle.click();
        }
      }
      lastY = y;
    }
    window.addEventListener('scroll', () => {
      if (!handled && !queued) {
        queued = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
